module.exports = __webpack_public_path__ + "img/1.94c18b43.png";